<template>
  <el-dialog :title="$t('addAgent')" :visible="isShowDialog" @close="onClosePopupButtonClick()" width="600px">
      <span id="modal-body">
        <div style="margin-bottom: 10px">
          <el-input type="text"
                    size="small"
                    v-model="keyword"
                    @input="isTyping = true"
                    placeholder="Filter by name">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <el-table
          id="popup-agent-list-table"
          :data="getAgentListDataSource()"
          :row-class-name="getRowClassName"
          header-row-class-name="table-header-color"
          :default-sort = "{prop: sortKey, order: sortBy}"
          style="width: 100%"
          v-loading="isTyping">
          <el-table-column
            type="index"
            width="50"
            :index="getRowNumber">
          </el-table-column>
          <el-table-column
            prop="name"
            :label="$t('agentName')">
              <template slot-scope="scope">{{ getAgentName(scope.row) }}</template>
          </el-table-column>
          <el-table-column align="right">
            <template slot-scope="scope">
              <el-button v-if="isAdded(scope.row) === false"
                         type="warning" size="small"
                         icon="el-icon-plus"
                         @click="onAddButtonClick(scope.row)">
                {{ $t('add') }}
              </el-button>
              <el-button v-if="isAdded(scope.row) === true"
                         type="success" size="small"
                         @click="onRemoveButtonClick(scope.row)">
                <i class="el-icon-remove minus-icon" style="color: red"></i>
                {{ $t('added') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="filterAgent().length"
            :page-size="pageSize"
            :current-page="currentPage"
            @current-change = "changePage">
          </el-pagination>
        </div>
      </span>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSaveButtonClick()">{{ $t('save') }} ({{ selectedAgentIdList.length }})</el-button>
        <el-button type="default" @click="onCancelButtonClick()">{{ $t('cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { STATUS } from '@/configs/constant'
import i18nMessages from '@/translations/Setting/ManageSetting/Market/components/PopupAgentList.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import { filterDataByKeyword, getDataOnPaging, adjustCurrentPage } from '@/services/general-service'
import { getStatusName } from '@/helpers'
import { debounce } from 'lodash'

export default {
  name: 'PopupAgentList',
  mixins: [AlertViewMixin],
  i18n: { messages: i18nMessages },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectedAgentIdList: {
      type: Array,
      default: function () {
        return []
      }
    },
    agentList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      isShowDialog: false,
      currentPage: 1,
      pageSize: 5,
      sortKey: 'name',
      sortBy: 'ascending',
      isTyping: false,
      keyword: ''
    }
  },
  watch: {
    visible: function (newValue) {
      this.isShowDialog = newValue
    },
    keyword: debounce(function () {
      this.isTyping = false
    }, 300),
    isTyping: function (value) {
      if (!value) {
        this.filterAgent()
      }
    }
  },
  methods: {
    changePage: function (page) {
      this.currentPage = page
    },
    getAgentListDataSource: function () {
      const filteredUserList = this.filterAgent()
      this.currentPage = adjustCurrentPage(filteredUserList.length, this.currentPage, this.pageSize)

      const agentList = getDataOnPaging(filteredUserList, this.currentPage, this.pageSize)
      return agentList
    },
    filterAgent: function () {
      const searchKeys = ['name']
      const filteredAgentList = filterDataByKeyword(this.agentList, this.keyword, searchKeys)

      return filteredAgentList
    },
    getRowNumber: function (index) {
      const rowOfPage = index + 1
      return rowOfPage + (this.pageSize * (this.currentPage - 1))
    },
    getAgentName: function (agent) {
      if (agent.isEnable === STATUS.DISABLE) {
        return `[${this.$t(getStatusName(STATUS.DISABLE))}] ${agent.name}`
      }

      return agent.name
    },
    getRowClassName: function ({ row, rowIndex }) {
      if (row.isEnable === 1) {
        return ''
      }
      return 'disable-row'
    },
    onClosePopupButtonClick: function () {
      this._closePopup()
    },
    onCancelButtonClick: function () {
      this._closePopup()
    },
    onAddButtonClick: function (agent) {
      this.selectedAgentIdList.push(agent.id)
    },
    onRemoveButtonClick: function (agent) {
      const index = this.selectedAgentIdList.indexOf(agent.id)
      if (index > -1) {
        this.selectedAgentIdList.splice(index, 1)
      }
    },
    isAdded: function (agent) {
      return (this.selectedAgentIdList.indexOf(agent.id) > -1)
    },
    onSaveButtonClick: function () {
      this.keyword = ''
      this.isShowDialog = false
      this.$emit('onSaveChange', this.selectedAgentIdList)
    },
    _closePopup: function () {
      this.keyword = ''
      this.isShowDialog = false
      this.$emit('onClose')
    }
  }
}
</script>
<style scope>
  .minus-icon {
    position:absolute;
    margin-top: -16px;
    margin-left: 46px;
  }
</style>
